export default __webpack_public_path__ + "static/media/vehelix_logo-01.0f28fc0d.svg";